export default __webpack_public_path__ + "static/media/walk-active.16597429.svg";